import {
  AgentDirectRebootRequest,
  AgentDirectRebootResponse
} from '@tryiris-ai/common.protojs/api/v1/agent_direct';
import type { Restart } from './types.js';
import { wrapApiCall } from '#~/api/index.js';
import { StudioError } from '#~/error/index.js';
import { nats } from '#~/nats/index.js';
import { isElectronApp } from '#~/electron/utils.js';
// ENG-4154: read the IdentityState store, not a per-consumer bridge poll.
import { resolveLinkedAgentId } from '#~/electron/index.js';

/**
 * Restart the agent.
 *
 * @param agentId - The ID of the agent to restart.
 */
export const restart: Restart = async (agentId) => {
  try {
    if (isElectronApp()) {
      const linkedAgentId = await resolveLinkedAgentId();

      if (agentId === linkedAgentId) {
        window.electron?.ipcRenderer?.invoke('bridge:reboot');

        return;
      }
    }

    await wrapApiCall(async () => {
      const response = await nats.agentConnection(agentId).request(
        `direct.authenticated.${agentId}.reboot.request`,
        AgentDirectRebootRequest.encode({
          $type: 'api.v1.AgentDirectRebootRequest'
        }).finish(),
        { timeout: 3000 }
      );

      const r = AgentDirectRebootResponse.decode(response.data);
      if (r.error?.message && r.error?.code !== 200) {
        throw new StudioError(`Unable to restart agent ${agentId}: ${r.error.message}`);
      }
      return r;
    });
  } catch (cause) {
    throw new StudioError(`Unable to restart agent: ${agentId}`, { cause });
  }
};
